var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { batch } from 'react-redux';
export var CHECKOUT_CONTEXT_ENUM;
(function (CHECKOUT_CONTEXT_ENUM) {
    CHECKOUT_CONTEXT_ENUM["BOOK_NOW"] = "book_now";
    CHECKOUT_CONTEXT_ENUM["CART"] = "cart";
})(CHECKOUT_CONTEXT_ENUM || (CHECKOUT_CONTEXT_ENUM = {}));
export var CHECKOUT_CONTEXT = Symbol("CHECKOUT_CONTEXT");
export var setCheckoutContext = function (checkoutContext) { return ({ type: CHECKOUT_CONTEXT, checkoutContext: checkoutContext }); };
export var BOOK_NOW = Symbol("BOOK_NOW");
export var bookNow = function (form, cb) { return function (dispatch, getState) {
    batch(function () {
        dispatch(({ type: BOOK_NOW, form: form, checkoutContext: CHECKOUT_CONTEXT_ENUM.BOOK_NOW }));
        if (cb)
            cb(form);
    });
}; };
export var UPDATE_GLOBAL_STATE = Symbol("UPDATE_GLOBAL_STATE");
export var updateGlobalState = function (state) { return (__assign({ type: UPDATE_GLOBAL_STATE }, state)); };
export var SET_LOGGED_IN = Symbol("LOGGED_IN");
export var setLoggedIn = function (isLoggedIn) { return function (dispatch, getState) {
    if (getState().globalReducer.isLoggedIn === isLoggedIn)
        return;
    dispatch({
        type: SET_LOGGED_IN,
        payload: isLoggedIn,
    });
}; };
